<template>
  <el-row>
    <el-row>
      <el-form ref="form" :model="form.model" :rules="form.rules" label-width="80px">
        <el-form-item label="操作步骤" prop="jobtaskid">
          <el-select v-model="form.model.jobtaskid" size="small" class="width100" :disabled="jobTaskId != null">
            <el-option v-for="item in jobTaskDictionary.items" :key="item[jobTaskDictionary.valueKey]"
                       :value="item[jobTaskDictionary.valueKey]" :label="item[jobTaskDictionary.textKey]"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </el-row>

    <el-row v-if="operateExist">
      <el-row class="column-name" justify="start">
        <span>操作设备参数</span>
      </el-row>
      <el-row>
        <asset-attr-list ref="operateAssetAttrList" @selection-change="operateSelectionChange"></asset-attr-list>
      </el-row>
    </el-row>

    <el-row v-if="checkExist">
      <el-row class="column-name" justify="start">
        <span>检查设备参数</span>
      </el-row>
      <el-row>
        <asset-attr-list ref="checkAssetAttrList" @selection-change="checkSelectionChange"></asset-attr-list>
      </el-row>
    </el-row>
  </el-row>
</template>

<script>
  import { Dictionary } from "@/util/common/dictionary";
  import AssetAttrList from "@/views/workorder/components/assetattr/list";
  import { WorkOrderServer } from '@/api'
  import { AuthInfo } from "@/util/user/authInfo";

  function createJobPlanSpec({$scope, type, assettype, assetattrid}) {
    return {
      jobplanid: $scope.jobPlanId,
      jobtaskid: $scope.form.model.jobtaskid,
      type: type,
      assettype: assettype,
      assetattrid: assetattrid,
      enterby: AuthInfo.userName,
      enterbyname: AuthInfo.userRealName,
      enterdate: new Date().Format('yyyy-MM-dd hh:mm:ss'),
      changeby: AuthInfo.userName,
      changebyname: AuthInfo.userRealName,
      changedate: new Date().Format('yyyy-MM-dd hh:mm:ss'),
    };
  }

  function createJobPlanSpecByAssetAttrs({$scope, type, assetAttrs}) {
    return assetAttrs.map(assetAttr => createJobPlanSpec({$scope, type, assettype: assetAttr.assettype, assetattrid: assetAttr.assetattrid}));
  }

  export default {
    name: "JobPlanSpecAdd",
    props: {
      'jobPlanId': {
      },
      'jobTaskId': {},
      'operateExist': {
        type: Boolean,
        default: true,
      },
      'checkExist': {
        type: Boolean,
        default: true,
      }
    },
    components: {
      AssetAttrList
    },
    data() {
      return {
        jobTaskDictionary: new Dictionary({items: []}),
        form: {
          model: {
            jobtaskid: ''
          },
          rules: {
            jobtaskid: [
              {required: true, message: '请选择操作步骤', trigger: 'change'}
            ]
          }
        },
        operateAssetAttrs: [],
        checkAssetAttrs: [],
      };
    },
    watch: {
      jobPlanId: {
        immediate: true,
        handler() {
          this.loadJobTasks();
        }
      },
      jobTaskId: {
        immediate: true,
        handler() {
          this.form.model.jobtaskid = this.jobTaskId;
        }
      }
    },
    methods: {
      loadJobTasks() {
        WorkOrderServer.jobTask.list({jobplanid: this.jobPlanId}).then((res) => {
          if (res.data.code === 200) {
            this.jobTaskDictionary = new Dictionary({items: res.data.result, valueKey: 'jobtaskid', textKey: 'description'});
          } else {
            this.$message.error(res.data.message);
          }
        }, (error) => {
          this.$message.error(error);
        });
      },
      operateSelectionChange(val) {
        this.operateAssetAttrs = val;
      },
      checkSelectionChange(val) {
        this.checkAssetAttrs = val;
      },
      submit() {
        this.$refs['form'].validate((res) => {
          if (res) {
            if (this.operateExist && this.operateAssetAttrs.length <= 0 && this.checkExist && this.checkAssetAttrs.length <= 0 ||
                this.operateExist && this.operateAssetAttrs.length <= 0 && !this.checkExist ||
                this.checkExist && this.checkAssetAttrs.length <= 0 && !this.operateExist) {
              this.$message.error('请选择设备点位类型');
              return false;
            }
            let jobPlanSpecs = [], operateAssetAttrs = this.operateAssetAttrs, checkAssetAttrs = this.checkAssetAttrs;
            jobPlanSpecs = jobPlanSpecs.concat(createJobPlanSpecByAssetAttrs({$scope: this, type: 'OPERATE', assetAttrs: operateAssetAttrs}));
            jobPlanSpecs = jobPlanSpecs.concat(createJobPlanSpecByAssetAttrs({$scope: this, type: 'CHECK', assetAttrs: checkAssetAttrs}));
            WorkOrderServer.jobPlanSpec.batchAdd(jobPlanSpecs).then(res => {
              if (res.data.code === 200) {
                this.$message.success('添加成功');
                this.$emit('success', {operation: 'batchAdd'});
              } else {
                this.$message.error(res.data.message);
              }
            }, error => this.$message.error(error));
          } else {
            return false;
          }
        });
      },
      clear() {
        this.form.model.jobtaskid = '';
        this.form.model.operateAssetAttrs = [];
        this.form.model.checkAssetAttrs = [];
        if (this.$refs['operateAssetAttrList']) {
          this.$refs['operateAssetAttrList'].clear();
        }
        if (this.$refs['checkAssetAttrList']) {
          this.$refs['checkAssetAttrList'].clear();
        }
      }
    },
  }
</script>

<style scoped>

</style>